// import { canUseDOM } from 'exenv';

export function personLoading(resp = {}, store = {}) {
  return {
    type: 'PERSON_LOADING',
    person: resp,
    store
  };
}

export function personLoaded(resp = {}, store = {}) {
  return {
    type: 'PERSON_LOADED',
    person: resp,
    store
  };
}

export function personLoadError(error, store = {}) {
  return {
    type: 'PERSON_ERROR',
    person: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
